// extracted by mini-css-extract-plugin
export var channel = "header-module--channel--a8fa2";
export var firstLine = "header-module--first-line--8de32";
export var header = "header-module--header--666b3";
export var highlight = "header-module--highlight--228bd";
export var intro = "header-module--intro--d6896";
export var separator = "header-module--separator--c0158";
export var taglets = "header-module--taglets--6522e";
export var tags = "header-module--tags--d9eed";
export var title = "header-module--title--de67b";